import { i18n } from "@/setup/i18n-setup";
import { ObservationStatusDescription } from "./observation-status-description";

export class ObservationStatusIssue {
	type:string = "";
	description:ObservationStatusDescription;
	descriptionToBeSent:boolean = false;

	public constructor(data:any){
		this.type = data.type;
		this.description = new ObservationStatusDescription(data.description);
		this.descriptionToBeSent = data.descriptionToBeSent;
	}

	public getText():string {
		return this.description.getText(i18n.locale);
	}
}